// Curtis Orthodontics (Coeur d'Alene ID) - single office. Sister brand to Post Falls
// Orthodontics (same owner, separate domain curtisbraces.com). Backend:
// bondLocations.ts CURTIS_CDA (brandId "curtis", catalog f0d505ea, Edge loc 2,
// procedure 279, DB 371). Native booking via ortho2-newpatient backend (WCF intake
// disabled). English-only.
import type { BrandConfig } from "./types";

export const curtis: BrandConfig = {
  slug: "curtis",
  brandId: "curtis",
  brandName: "Curtis Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/05f59ebd-1874-408d-aea1-dc033c8d500b.png",
  phone: "(208) 772-7272",
  phoneHref: "tel:+12087727272",
  theme: { primary: "#38557C", primaryDark: "#24384F" }, // scoured 2026-07-20 curtisbraces.com (slate-blue)
  locales: ["en"],
  locations: {
    CURTIS_CDA: {
      id: "CURTIS_CDA",
      name: "Coeur d'Alene",
      addressLines: ["215 W Canfield Ave", "Coeur d'Alene, ID 83815"],
      mapsUrl: "https://maps.google.com/?q=215+W+Canfield+Ave+Coeur+d%27Alene+ID+83815",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { COEUR_DALENE: "CURTIS_CDA", CDA: "CURTIS_CDA", CURTIS: "CURTIS_CDA" },
};
